var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.checkDownload)?_c('a',{staticClass:"donation_content_btn",attrs:{"href":_vm.fileData.org_url,"target":"_blank","download":""}},[_vm._v("후원하기")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }